/**
 * Takes an Integer value of seconds (e.g. 83) and converts it into a
 * human-readable formatted string (e.g. '1:23').
 */
export default function formatSeconds(seconds) {
  return "".concat(Math.floor(seconds / 60), ":").concat(String(seconds % 60).padStart(2, '0'));
}